import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import {
  LocationSuggestion,
  LocationDetailsResponse,
} from "../models/LocationSearch";

export default class LocationStore {
  locationSuggestions: LocationSuggestion[] = [];
  loadingSuggestions: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  /*------------------ Location Suggestions Loader ------------------*/
  getLoadingSuggestions = () => this.loadingSuggestions;

  setLoadingSuggestions = (val: boolean) => {
    this.loadingSuggestions = val;
  };

  getLocationSuggestions = () => this.locationSuggestions;

  setLocationSuggestions = (suggestions: LocationSuggestion[]) => {
    this.locationSuggestions = suggestions;
  };

  clearLocationSuggestions = () => {
    this.locationSuggestions = [];
  };

  /*------------------ Autocomplete Search ------------------*/
  searchLocations = async (input: string) => {
    if (!input.trim()) {
      this.clearLocationSuggestions();
      return;
    }

    this.setLoadingSuggestions(true);
    try {
      const result = await agent.Places.autocomplete(input);
      runInAction(() => {
        this.setLocationSuggestions(result.suggestions || []);
      });
    } catch (error) {
      console.error("Error fetching location suggestions:", error);
      this.clearLocationSuggestions();
    } finally {
      this.setLoadingSuggestions(false);
    }
  };

  /*------------------ Get Place Details ------------------*/
  getPlaceDetails = async (
    placeId: string
  ): Promise<LocationDetailsResponse | null> => {
    try {
      const result = await agent.Places.details(placeId);
      return result;
    } catch (error) {
      console.error("Error fetching place details:", error);
      return null;
    }
  };
}
